// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".counter[data-v-07ec9a21] {\n  margin-top: 8px;\n  color: #555;\n}\n", ""]);
// Exports
module.exports = exports;
